import { string, object, array } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'
import { hasVisibleCharacters } from '@calendly/rich-text-editor'

import { CRM_SHAREABLE } from 'features/mfe_shareable'

const MAX_EMAILS = 10
const CHARACTER_LIMIT = 25_000

export const hasToManyEmails = ({ cc, bcc, ccCurrentInputValue, bccCurrentInputValue }) => {
  if (cc.length + bcc.length > MAX_EMAILS) return true

  return (cc.length + bcc.length === MAX_EMAILS) && (Boolean(ccCurrentInputValue) || Boolean(bccCurrentInputValue))
}

const getMaxEmailsValidationTest = () => [
  'maxEmails',
  I18n.t('publisher.send_from_calendly.errors.too_many_emails'),
  (_, { parent }) => !hasToManyEmails(parent)
]

export const getEmailErrorMessage = () => I18n.t('publisher.send_from_calendly.errors.invalid_email')

export const getValidationSchema = (source = null) => object({
  sendWith: object().required(),
  to: array()
    .of(object({
      email: string().email(getEmailErrorMessage()).required()
    }))
    .min(1).max(1),
  cc: array()
    .of(object({
      email: string().email(getEmailErrorMessage()).required(),
    }))
    .test(...getMaxEmailsValidationTest()),
  bcc: array()
    .of(object({
      email: string().email(getEmailErrorMessage()).required(),
    }))
    .test(...getMaxEmailsValidationTest()),
  subject: source === CRM_SHAREABLE ? string() : string().required(),
  body: object().test('validateBody', '', (body, { createError }) => {
    if (body.html?.length > CHARACTER_LIMIT) {
      return createError({ message: I18n.t('publisher.scheduled_events.meeting_notes.too_long', { count: CHARACTER_LIMIT }) })
    }

    if (!body.delta && body.html && body.html.length) {
      return true
    }

    if (body.delta && hasVisibleCharacters(body)) {
      return true
    }

    return createError({
      message: I18n.t('publisher.workflows.errors.body_required')
    })
  }),
})
